export var titleInitialValues = {
    owner: {},
    // Start with no name row — the user adds one explicitly via "Přidat název"
    // instead of having to edit a pre-generated empty (and invalid) row.
    names: [],
    languages: [{ role: {}, language: {} }],
    subjects: [],
    textContents: [],
    supportingResources: [],
    publicationPlaces: [{ city: "" }],
    audiences: [],
    titlePublishers: [{ publisher: {}, role: {} }],
    editionNumber: undefined,
    editionStatement: undefined,
    ageFrom: undefined,
    ageTo: undefined,
    doi: undefined,
    illustrationsNote: undefined,
    imprint: undefined,
    commentForAgency: undefined,
    titleContributions: undefined,
    titleCollections: [],
};
